import { Box } from '@material-ui/core';
import React from 'react';
import { InboxPageContext } from 'src/context/inboxPageContext';
import { InboxContent } from 'src/components/Inbox/InboxContent';
import { InboxSidebar } from 'src/components/Inbox/InboxSidebar';

export const InboxPage = () => {
  const [selectedNotification, setSelectedNotification] = React.useState(null);

  const inboxPageContextValue = React.useMemo(
    () => ({
      selectedNotification,
      setSelectedNotification,
    }),
    [selectedNotification, setSelectedNotification],
  );

  return (
    <InboxPageContext.Provider value={inboxPageContextValue}>
      <Box display="flex" height={1}>
        <InboxSidebar />
        <InboxContent />
      </Box>
    </InboxPageContext.Provider>
  );
};
